Vue.component('makeAppointment', {
    data() {
        return {
            root: this.$root,
            appointmentType: '',
            datepicker: null,
            makeAppointment: false,
            unavailableError: false,
            sortedShopList: [],
            appointmentTypes: [],
            availableDays: [],
            availableTimes: [],
            cachedAppTypes: [],
            cachedDays: [],
            cachedTimes: [],
            selectedTime: null,
            showAppointmentTypes: false,
            showDatepicker: false,
            appointment: {
                CustomerNumber: '',
                AgendaId: '',
                AppointmentType: '',
                AppointmentTypeId: '',
                Date: '',
                StartTime: '',
                EndTime: '',
                Email: document.forms['make-appointment-form'].elements.Email.value,
                ResourceId: null,
                FirstName: document.forms['make-appointment-form'].elements.FirstName.value,
                LastName: document.forms['make-appointment-form'].elements.LastName.value,

                PostalCode: '',
                PhoneNumber: '',
                Message: ''

            },
        };
    },
    mounted() {
        if (document.forms['make-appointment-form'].elements.CustomerNumber.hasAttribute('data-value')) {
            // Channel marketing
            this.appointment.CustomerNumber = document.forms['make-appointment-form'].elements.CustomerNumber.getAttribute('data-value');
        } else {
            // Regular website
            this.appointment.CustomerNumber = document.forms['make-appointment-form'].elements.CustomerNumber.value;
        }

        this.datepicker = flatpickr(document.querySelector('.js-datepicker'), {
            locale: document.documentElement.lang.split('-')[0],
            altInput: true,
            altFormat: 'j F Y',
            inline: true,
            enableTime: false,
            minDate: 'today',
            time_24hr: true,
            onMonthChange: (selectedDates, dateStr, instance) => {
                this.getBookableDays(this.appointment.AppointmentTypeId);
            },
            onYearChange: (selectedDates, dateStr, instance) => {
                this.getBookableDays(this.appointment.AppointmentTypeId);
            },
            onChange: (selectedDates, dateStr, instance) => {
                const agendaId = this.availableDays.filter(d => d.date === dateStr)[0].agendaId;
                const appointmentTypeId = this.availableDays.filter(d => d.date === dateStr)[0].appointmentTypeId;

                this.appointment.StartTime = '';
                this.appointment.EndTime = '';
                this.appointment.ResourceId = null;

                this.appointment.AgendaId = agendaId;
                this.appointment.AppointmentTypeId = appointmentTypeId;
                this.appointment.Date = dateStr;

                this.getBookableTimes(agendaId, dateStr, appointmentTypeId);
            },
        });

        if (document.forms['make-appointment-form'].elements.Shop.querySelector('[selected]')) {
            this.appointment.CustomerNumber = document.forms['make-appointment-form'].elements.Shop.querySelector('[selected]').value;
        }

        if (website.loggedIn) {
            this.setFormFieldsReadonly();
        }

        this.initFormFill();
    },
    watch: {
        'appointment.CustomerNumber': function (customerNumber) {
            let selectedCustomer;

            if (document.forms['make-appointment-form'].elements.Shop.type.toLowerCase() === 'hidden') {
                // Channel marketing (hidden input field)
                selectedCustomer = document.forms['make-appointment-form'].elements.Shop;
            } else {
                // Regular website
                selectedCustomer = document.forms['make-appointment-form'].elements.Shop.querySelector(`[value="${customerNumber}"]`);
            }

            if (selectedCustomer !== null && selectedCustomer.hasAttribute('data-api') && selectedCustomer.getAttribute('data-api') === 'true') {
                this.showAppointmentTypes = true;
            } else {
                this.showAppointmentTypes = false;
            }

            if (this.showAppointmentTypes) {
                this.resetAppointment();

                this.appointment.AppointmentType = '';
                this.appointment.AgendaId = '';

                this.appointment.Date = '';
                this.appointment.StartTime = '';
                this.appointment.EndTime = '';
                this.selectedTime = null;
                this.datepicker.setDate('', false);

                this.getAppointmentTypes();
            }
        },
        'appointment.AppointmentTypeId': function (appointmentTypeId) {

            //const selectedAppointmentType = document.forms['make-appointment-form'].elements.AppointmentType.querySelector(`[value="${appointmentTypeId}"]`);
            //let appointmentTypeText = selectedAppointmentType !== null ? selectedAppointmentType.textContent : '';

            if (appointmentTypeId === '') {
                this.resetAppointment();
                this.showDatepicker = false;
                this.makeAppointment = false;
                this.appointment.AppointmentType = '';
                this.appointment.AgendaId = '';

                this.appointment.Date = '';
                this.appointment.StartTime = '';
                this.appointment.EndTime = '';
                this.selectedTime = null;
                this.datepicker.setDate('', false);

            } else {

                let appointmentTypeText = '';

                for (let i = 0; i < this.appointmentTypes.length; i += 1) {
                    const ap = this.appointmentTypes[i];
                    if (ap.id === appointmentTypeId) {
                        appointmentTypeText = ap.name;
                        break;
                    }
                }

                this.showDatepicker = true;
                this.makeAppointment = true;
                this.appointment.AppointmentType = appointmentTypeText;

                this.appointment.Date = '';
                this.appointment.StartTime = '';
                this.appointment.EndTime = '';
                this.selectedTime = null;
                this.datepicker.setDate('', false);

                this.getBookableDays(appointmentTypeId);
            }
        },
        appointmentType(type) {
            if (type === document.forms['make-appointment-form'].elements.SetAppointmentType[0].value && this.appointment.CustomerNumber !== '') {
                this.makeAppointment = true;
                this.getBookableDays();
            } else {
                this.resetAppointment();
                this.makeAppointment = false;
            }
        },
        availableDays(days) {
            if (days.length > 0) {
                this.datepicker.set('disable', []);
                this.datepicker.set('enable', this.availableDays.map(d => d.date));
            } else {
                this.datepicker.set('enable', []);
                this.disableAllDays();
            }

            if (this.appointment.Date === '') {
                this.datepicker.setDate('', false);
            }
        },
        /*
        selectedTime: {
            handler(uid) {
                var time = this.availableTimes.filter(t => t.uniqueId === uid)[0];

                this.appointment.StartTime = time.startTime;
                this.appointment.EndTime = time.endTime;
                this.appointment.ResourceId = time.resourceId;
            },
            deep: true,
        },*/
    },
    methods: {
        initFormFill() {
            if (typeof Storage !== 'undefined') {
                if (localStorage.makeAppointmentForm === 'true') {
                    this.refillFormFields();
                }

                window.addEventListener('beforeunload', this.storeFormFields);
            }
        },
        refillFormFields() {
            // Only select form fields which have been marked to be stored
            const contactDetailsFieldsetInputs = document.forms['make-appointment-form'].querySelectorAll('.js-form__group__input--store');

            for (let i = 0; i < contactDetailsFieldsetInputs.length; i += 1) {
                const input = contactDetailsFieldsetInputs[i];
                let bFillValue = true;
                
                if ((input.type === 'select-one' && input.disabled) || input.readOnly ||
                    ((input.getAttribute('type') === 'hidden' || website.loggedIn || window.location.href.search("[?&]customerNumber=") !== -1) && input.getAttribute('name') === 'CustomerNumber')) {
                    bFillValue = false;
                }

                if (bFillValue) {
                    switch (input.tagName.toLowerCase()) {
                        case 'input':
                            switch (input.getAttribute('type')) {
                                case 'checkbox':
                                case 'radio':
                                    // The checkboxes on the form are not on the Vue model and if radio buttons were present each one within
                                    // a group would be iterated on here, therefore we cannot check the Vue model property based on ID
                                    if (localStorage[input.getAttribute('id')] === 'true') {
                                        input.checked = true;
                                    } else {
                                        input.checked = false;
                                    }
                                    break;

                                default:    // text, email, number, tel, etc.
                                    if (typeof this.appointment[input.getAttribute('name')] !== 'undefined') {
                                        this.appointment[input.getAttribute('name')] = localStorage[input.getAttribute('name')];
                                    } else {
                                        if (typeof localStorage[input.getAttribute('name')] !== 'undefined') {
                                            input.value = localStorage[input.getAttribute('name')];
                                        }
                                    }
                                    break;
                            }
                            break;

                        default:    // textarea, select
                            if (typeof this.appointment[input.getAttribute('name')] !== 'undefined') {
                                this.appointment[input.getAttribute('name')] = localStorage[input.getAttribute('name')];
                            } else {
                                input.value = localStorage[input.getAttribute('name')];
                            }
                            break;
                    }
                }

                if (input.getAttribute('name') === 'CustomerNumber') {
                    if (input.hasAttribute('data-value')) {
                        this.appointment.CustomerNumber = input.getAttribute('data-value');
                    } else {
                        //this.appointment.CustomerNumber = input.value;
                    }
                }
            }
        },
        storeFormFields() {
            if (localStorage.overridePrefillForm !== 'true') {
                // Only select form fields which have been marked to be stored
                const contactDetailsFieldsetInputs = document.forms['make-appointment-form'].querySelectorAll('.js-form__group__input--store');

                localStorage.makeAppointmentForm = true;

                for (let i = 0; i < contactDetailsFieldsetInputs.length; i += 1) {
                    const input = contactDetailsFieldsetInputs[i];

                    if (typeof input.value !== 'undefined') {
                        let bStoreValue = true;

                        if ((input.type === 'select-one' && input.disabled) || input.readOnly) {
                            bStoreValue = false;
                        }

                        if (bStoreValue) {
                            switch (input.tagName.toLowerCase()) {
                                case 'input':
                                    switch (input.getAttribute('type')) {
                                        case 'checkbox':
                                        case 'radio':
                                            if (input.checked) {
                                                localStorage[input.getAttribute('id')] = true;
                                            } else {
                                                localStorage[input.getAttribute('id')] = false;
                                            }
                                            break;

                                        default:    // text, email, number, tel, etc.
                                            localStorage[input.getAttribute('name')] = input.value;
                                            break;
                                    }
                                    break;

                                default:    // textarea, select
                                    localStorage[input.getAttribute('name')] = input.value;
                                    break;
                            }
                        }
                    }
                }
            } else {
                // Allow prefill next time as the unload event has passed meaning the prefill wasn't erroneously executed
                localStorage.removeItem('overridePrefillForm');
            }
        },
        unstoreFormFields() {
            // Only select form fields which have been marked to be stored
            const contactDetailsFieldsetInputs = document.forms['make-appointment-form'].querySelectorAll('.js-form__group__input--store');

            for (let i = 0; i < contactDetailsFieldsetInputs.length; i += 1) {
                const input = contactDetailsFieldsetInputs[i];

                switch (input.tagName.toLowerCase()) {
                    case 'input':
                        switch (input.getAttribute('type')) {
                            case 'checkbox':
                            case 'radio':
                                localStorage.removeItem(input.getAttribute('id'));
                                break;

                            default:    // text, email, number, tel, etc.
                                localStorage.removeItem(input.getAttribute('name'));
                                break;
                        }
                        break;

                    default:    // textarea, select
                        localStorage.removeItem(input.getAttribute('name'));
                        break;
                }
            }

            localStorage.makeAppointmentForm = false;
            localStorage.overridePrefillForm = true;
        },
        setFormFieldsReadonly() {
            const contactDetailsFieldsetInputs = document.forms['make-appointment-form'].elements;

            for (let i = 0; i < contactDetailsFieldsetInputs.length; i += 1) {
                const input = contactDetailsFieldsetInputs[i];

                if (typeof input.value !== 'undefined') {
                    if (input.type === 'select-one' && input.value !== '' && input.name !== 'CustomerNumber') {
                        input.disabled = true;
                        input.parentElement.classList.add('disabled');
                    }

                    if (input.value !== '') {
                        input.readOnly = true;
                    }
                }
            }
        },
        sortedShopName(shop) {
            if (shop.name.endsWith(shop.city)) {
                return `${shop.name} - (${shop.distance}km)`;
            } else {
                return `${shop.name} - ${shop.city} - (${shop.distance}km)`;
            }
        },
        sortShoplistByZipcode(e) {
            let sortShopList = false;
            const zipcode = e.target.value;

            if (!website.loggedIn /*&& this.appointment.CustomerNumber === ''*/) {
                sortShopList = true;
            }

            if (website.loggedIn &&
                (
                    !document.forms['make-appointment-form'].elements.PostalCode.readOnly /*&&
                    document.forms['make-appointment-form'].elements.CustomerNumber.value === ''*/
                )
            ) {
                sortShopList = true;
            }

            if (sortShopList && zipcode.length > 0) {
                fetch(`/api/geolocation/ordershops?zipcode=${zipcode}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                }).then(response => response.json()).then((shops) => {
                    this.appointment.CustomerNumber = '';
                    this.sortedShopList = shops;
                    this.resetAppointment();
                    Vue.nextTick(() => {
                        fInitCustomSelects();
                    });
                });
            }
        },
        disableAllDays() {
            let minDay = 1;
            let minMonth = (this.datepicker.currentMonth);
            let maxMonth = minMonth;
            let minYear = this.datepicker.currentYear;
            let maxYear = minYear;

            const minDateElem = this.datepicker.days.firstElementChild;

            if (minDateElem.classList.contains('prevMonthDay')) {
                minDay = parseInt(minDateElem.textContent, 10);
                minMonth -= 1;
            }

            const maxDateElem = this.datepicker.days.lastElementChild;

            if (maxDateElem.classList.contains('nextMonthDay')) {
                maxMonth += 1;
            }

            if (minDateElem.getAttribute('aria-label').indexOf(minYear) === -1) {
                minYear -= 1;
            }

            if (maxDateElem.getAttribute('aria-label').indexOf(maxYear) === -1) {
                maxYear += 1;
            }

            const firstDay = new Date(minYear, minMonth, minDay);
            const lastDay = new Date(maxYear, maxMonth, parseInt(maxDateElem.textContent, 10));

            this.datepicker.set('disable', [
                {
                    from: firstDay,
                    to: lastDay,
                },
            ]);
        },
        getAppointmentTypes() {

            this.availableTimes = [];

            this.unavailableError = false;
            const cacheKey = `${this.appointment.CustomerNumber}_appointmentTypes`;

            if (this.cachedAppTypes.length > 0 && this.cachedAppTypes.some(cache => cache.key === cacheKey)) {
                this.appointmentTypes = this.cachedAppTypes.find(cache => cache.key === cacheKey).appointmentTypes;

                //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                //if (this.appointmentTypes.length === 1) {
                this.appointment.AppointmentTypeId = ''; //this.appointmentTypes[0].id;
                //}

                Vue.nextTick(() => {
                    fInitCustomSelects();
                });

            } else {
                fetch(`/api/agenda/appointmenttypes?customerNumber=${this.appointment.CustomerNumber}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin'
                })
                .then(response => response.json()).then((appointmentTypesResponse) => {
                    this.appointmentTypes = appointmentTypesResponse;

                    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                    //if (this.appointmentTypes.length === 1) {
                    this.appointment.AppointmentTypeId = ''; //this.appointmentTypes[0].id;
                    //}

                    this.cachedAppTypes.push({
                        key: cacheKey,
                        appointmentTypes: appointmentTypesResponse
                    });

                    Vue.nextTick(() => {
                        fInitCustomSelects();
                    });
                });
            }
        },
        getBookableDays(appTypeId) {

            this.availableTimes = [];

            this.unavailableError = false;
            const cacheKey = `${this.appointment.CustomerNumber}${this.datepicker.currentYear}${this.datepicker.currentMonth + 1}${this.appointment.AppointmentTypeId}`;

            if (typeof appTypeId === 'undefined') {
                appTypeId = -1;
            }

            if (this.cachedDays.length > 0 && this.cachedDays.some(cache => cache.key === cacheKey)) {
                this.availableDays = this.cachedDays.find(cache => cache.key === cacheKey).days;
            } else {
                fetch(`/api/agenda/bookabledays?customerNumber=${this.appointment.CustomerNumber}&appointmentType=${appTypeId}&year=${this.datepicker.currentYear}&month=${this.datepicker.currentMonth + 1}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin'
                })
                .then(response => response.json()).then((bookableDaysResponse) => {
                    this.availableDays = bookableDaysResponse;

                    this.cachedDays.push({
                        key: cacheKey,
                        days: bookableDaysResponse
                    });
                });
            }
        },
        getBookableTimes(agendaId, date, appointmentTypeId) {
            this.unavailableError = false;
            const cacheKey = `${this.appointment.CustomerNumber}${agendaId}${date.replace(/-/g, '')}${appointmentTypeId}`;

            if (this.cachedTimes.length > 0 && this.cachedTimes.some(cache => cache.key === cacheKey)) {
                this.availableTimes = this.cachedTimes.find(cache => cache.key === cacheKey).times;

                Vue.nextTick(() => {
                    fInitCustomSelects();
                });
            } else {
                fetch(`/api/agenda/bookabletimes?customerNumber=${this.appointment.CustomerNumber}&agendaId=${agendaId}&date=${date}&appointmentTypeId=${appointmentTypeId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                })
                .then(response => response.json()).then((bookableTimesResponse) => {
                    // Get objects with unique startTime
                    this.availableTimes = bookableTimesResponse.filter((t, i) => bookableTimesResponse.findIndex(b => b.startTime === t.startTime) === i);

                    this.cachedTimes.push({
                        key: cacheKey,
                        times: this.availableTimes,
                    });

                    Vue.nextTick(() => {
                        fInitCustomSelects();
                    });
                });
            }
        },
        resetAppointment() {
            this.unavailableError = false;
            this.appointment.AgendaId = '';
            this.appointment.AppointmentTypeId = '';
            this.appointment.Date = '';
            this.appointment.StartTime = '';
            this.appointment.EndTime = '';
            this.appointment.ResourceId = null;
        },
        calcStartEndTime() {
            var time = this.availableTimes.filter(t => t.uniqueId === document.forms['make-appointment-form'].elements.selectedTime.value)[0];

            if (time != null) {
                this.appointment.StartTime = time.startTime;
                this.appointment.EndTime = time.endTime;
                this.appointment.ResourceId = time.resourceId;
            }
        },
        submitAppointment(form) {

            console.log('submitAppointment');

            this.appointment.Email = document.forms['make-appointment-form'].elements.Email.value;
            this.appointment.FirstName = document.forms['make-appointment-form'].elements.FirstName.value;
            this.appointment.LastName = document.forms['make-appointment-form'].elements.LastName.value;

            this.appointment.PostalCode = document.forms['make-appointment-form'].elements.PostalCode.value;
            this.appointment.PhoneNumber = document.forms['make-appointment-form'].elements.PhoneNumber.value;
            this.appointment.Message = document.forms['make-appointment-form'].elements.Message.value;

            fetch('/api/agenda/appointment', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify(this.appointment),
                }).then(response => response.json()).then((appointmentResponse) => {
                if (appointmentResponse.success) {

                    console.log('submitAppointment success');

                } else if (appointmentResponse.FriendlyStatus === 'Unavailable') {

                    console.log('submitAppointment Unavailable');

                    this.unavailableError = true;
                }

                console.log(appointmentResponse);

                if (typeof Storage !== 'undefined') {
                    // Disable prefilling the form on the next page load once the form successfully submits
                    this.unstoreFormFields();
                }

                form.submit();

                return false;
                });

        }/*,
        trackEcommerce() {
            window.dataLayer = window.dataLayer || [];

            dataLayer.push({
                event: 'trackTransaction',
                transactionId: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15), // Random Id
                transactionTotal: parseFloat(this.$root.cart[cartindex].products.reduce((a, b) => a + (b.price - (b.price * (b.vatPercentage / (100 + b.vatPercentage)))), 0).toFixed(2)), // Calculate price without VAT
                transactionTax: parseFloat(this.$root.cart[cartindex].totalVat.replace('.', '').replace(',', '.')),
                transactionProducts: this.$root.cart[cartindex].products.map(p => ({
                    sku: p.code,
                    name: `${p.collection}, ${p.displayName}`,
                    category: p.topLevelContent,
                    price: parseFloat((p.price - (p.price * (p.vatPercentage / (100 + p.vatPercentage)))).toFixed(2)),
                    quantity: p.quantity,
                })),
            });
        },*/
    },
});